import { trim } from 'lodash';

import { sanitize, sanitizeRichContent } from 'utils/dompurify';

import * as styled from './styles';

type LongTextProps = {
  className?: string;
  text: string;
  rich?: boolean;
};

/* eslint react/no-danger: 0 */
export const LongText = ({ className, text, rich }: LongTextProps) => (
  <styled.LongText
    className={className}
    rich={rich}
    dangerouslySetInnerHTML={{
      __html: rich ? sanitizeRichContent(trim(text)) : sanitize(trim(text)),
    }}
  />
);
